import {Component} from "@angular/core";


export class Header {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "a2-header",
    template: "<ng-content></ng-content>"
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}


export class Footer {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "a2-footer",
    template: "<ng-content></ng-content>"
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
